import { render, staticRenderFns } from "./OnlineFormTabJVXE.vue?vue&type=template&id=62320b28&scoped=true&"
import script from "./OnlineFormTabJVXE.vue?vue&type=script&lang=js&"
export * from "./OnlineFormTabJVXE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62320b28",
  null
  
)

export default component.exports